<footer [ngClass]="isPublic ? 'bg-[#000A73]' : 'bg-navy-700'">
  <div
    class="mx-auto max-w-7xl text-white md:px-8"
    [ngClass]="isPublic ? 'px-5 py-10' : 'p-5'"
  >
    <div
      class="flex flex-col flex-wrap gap-x-7 gap-y-5 border-b-[1px] border-b-[#CCCCCC] pb-16 text-sm md:flex-row md:items-center md:gap-y-0 md:border-b-white md:pb-5"
    >
      <a
        href="https://business.comcast.com/privacy/nitel-privacy-policy"
        class="comcast-white-link !no-underline"
        target="_blank"
        >Privacy Policy</a
      >
      <a
        href="https://www.xfinity.com/privacy/your-privacy-choices"
        class="comcast-white-link !no-underline"
        target="_blank"
        >Your Privacy Choices</a
      >
      <a
        href="https://www.xfinity.com/privacy/policy/staterights#california"
        class="comcast-white-link !no-underline"
        target="_blank"
        >Notice at Collection</a
      >
      <a
        href="https://www.xfinity.com/corporate/legal/visitoragreement"
        class="comcast-white-link !no-underline"
        target="_blank"
        >Visitor Agreement</a
      >
      <a
        href="https://business.comcast.com/enterprise/terms-conditions/nitel"
        class="comcast-white-link !no-underline"
        target="_blank"
        >Terms &amp; Conditions</a
      >
      @if (!isPublic) {
        <a routerLink="/noc-policy" class="comcast-white-link !no-underline">
          NOC Policy
        </a>
      }
    </div>

    <div class="mt-5 text-[11px] text-[#CCCCCC] md:mt-10 md:text-[#EFEFEF]">
      ©{{ currYear }} Comcast Corporation. All Rights Reserved
    </div>
  </div>
</footer>
